import {
  Col,
  Row,
  Upload,
  Image as AntImage,
  Button,
  UploadProps,
  message,
  Modal,
} from "antd";
import React, { FunctionComponent, useEffect, useState } from "react";
import { Profile } from "./model/Profile";
import ImgCrop from "antd-img-crop";
import { ProfileDocument } from "./model/Document";
import {
  ExclamationCircleFilled,
  InboxOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import AxiosAPI from "../../../../../helpers/AxiosAPI";
import Dragger from "antd/es/upload/Dragger";
import { FileAttachmentNoActionButton } from "./components/settings/FileAttachmentNoActionButton";

interface DocumentListItemProps {
  children?: React.ReactNode;
  profile: Profile;
}
interface FileObject {
  name: string;
  uid: string;
  thumbUrl: string;
  url: string;
  state: string;
  s3Key: string;
  type: string;
}
const BusinessDocuments: FunctionComponent<DocumentListItemProps> = ({
  children,
  ...props
}) => {
  const { profile }: any = props;

  React.useEffect(() => {
    if (profile.name) {
      set_profileVideoUrl(profile.profileVideoUrl);
      set_documents(profile.documents);
    }
  }, [profile]);

  const [currentFileAttachmentType, setcurrentFileAttachmentType] =
    useState("IMAGE");
  const [bannerCarouselList, setBannerCarouselList] = useState<FileObject[]>(
    []
  );
  const [imageUrlBanner, setImageUrlBanner] = useState<string>(
    "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
  );
  const [imageUrlLogo, setImageUrlLogo] = useState<string>(
    "https://img.freepik.com/premium-vector/account-icon-user-icon-vector-graphics_292645-552.jpg"
  );

  const fallBackImage =
    "data:image/png;base64,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";

  const [sliderList, setSliderList] = useState<FileObject[]>([]);
  const [documents, set_documents] = useState([]);
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [fileList, setFileList] = useState<FileObject[]>([]);
  const [profileVideoUrl, set_profileVideoUrl] = useState("");
  ////////////////////////////////////////////////////////////////////////
  // - ATTACHMENTS -

  //MINI_SITE_BANNER
  useEffect(() => {
    documents.map((doc: any) => {
      const docUrl: string =
        "https://api-live.supplyzone.ai/home/download-attachment/" + doc.s3Key;

      /*
            console.log(
                " ???????????????????????  MINI_SITE_BANNER ",
                doc.type === "MINI_SITE_BANNER",
                [doc.type, "MINI_SITE_BANNER"]
            );
            */

      if (doc.type === "MINI_SITE_BANNER") {
        //console.log("######################## MINI_SITE_BANNER URL = ", docUrl);

        setImageUrlBanner(docUrl);
      }
    });
  }, [documents]);

  //LOGO
  useEffect(() => {
    documents.map((doc: any) => {
      const docUrl: string =
        "https://api-live.supplyzone.ai/home/download-attachment/" + doc.s3Key;

      /*
            console.log(" ???????????????????????  LOGO ", doc.type === "LOGO", [
                doc.type,
                "LOGO",
            ]);
            */

      if (doc.type === "LOGO") {
        console.log("######################## LOGO URL = %DOC%", doc);

        setImageUrlLogo(docUrl);
      }
    });
  }, [documents]);

  //MINISITE_BANNER_CAROUSEL
  useEffect(() => {
    const newFileList: Array<any> = documents.map(
      (doc: any, docNumber: number) => {
        const docUrl: string =
          "https://api-live.supplyzone.ai/home/download-attachment/" +
          doc.s3Key;

        /*
                console.log(
                    " ???????????????????????  MINI_SITE_BANNER ",
                    doc.type === "MINI_SITE_BANNER",
                    (doc.type, "MINI_SITE_BANNER")
                );
                */

        if (doc.type === "MINI_SITE_BANNER") {
          const docItem: any = {
            name: doc.label,
            uid: Math.random().toString(36).substring(7) + "-" + docNumber,
            url: docUrl,
            thumbUrl: docUrl,
            state: "done",
            s3Key: doc.s3Key,
            type: doc.type,
          };

          return docItem;
        }
      }
    );

    const filteredNewFileList = newFileList.filter(function (el) {
      return typeof el === "object" && "uid" in el;
    });

    setBannerCarouselList(filteredNewFileList);

    /*
        console.log(
            "######################## MINI_SITE_BANNER ",
            filteredNewFileList
        );
        */
  }, [documents]);

  //SLIDE_IMAGE
  useEffect(() => {
    const newFileList: Array<any> = documents.map(
      (doc: any, docNumber: number) => {
        const docUrl: string =
          "https://api-live.supplyzone.ai/home/download-attachment/" +
          doc.s3Key;

        /*
                console.log(
                    " ???????????????????????  SLIDE_IMAGE ",
                    doc.type === "SLIDE_IMAGE",
                    (doc.type, "SLIDE_IMAGE")
                );
                */

        if (doc.type === "SLIDE_IMAGE") {
          const docItem: any = {
            name: doc.label,
            uid: Math.random().toString(36).substring(7) + "-" + docNumber,
            url: docUrl,
            thumbUrl: docUrl,
            state: "done",
            s3Key: doc.s3Key,
            type: doc.type,
          };

          return docItem;
        }
      }
    );

    const filteredNewFileList = newFileList.filter(function (el) {
      return typeof el === "object" && "uid" in el;
    });

    setSliderList(filteredNewFileList);

    //console.log("######################## SLIDE_IMAGE ", filteredNewFileList);
  }, [documents]);

  //OTHER DOCS
  useEffect(() => {
    const newFileList: Array<any> = documents.map(
      (doc: any, docNumber: number) => {
        if (!["LOGO", "MINI_SITE_BANNER", "SLIDE_IMAGE"].includes(doc.type)) {
          const docUrl: string =
            "https://api-live.supplyzone.ai/home/download-attachment/" +
            doc.s3Key;

          const docItem: any = {
            name: doc.label,
            uid: Math.random().toString(36).substring(7) + "-" + docNumber,
            url: docUrl,
            thumbUrl: docUrl,
            state: "done",
            s3Key: doc.s3Key,
            type: doc.type,
          };

          return docItem;
        }
      }
    );

    const filteredNewFileList = newFileList.filter(function (el) {
      return typeof el === "object" && "uid" in el;
    });

    setFileList(filteredNewFileList);

    //console.log("######################## ALL ", filteredNewFileList);
  }, [documents]);

  const propsLogo: UploadProps = {
    beforeUpload(file) {
      setLoadingLogo(true);
      return new Promise((resolve: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const imgData: string = reader.result as string;

          setImageUrlLogo(imgData);

          //console.log("****", imgData);

          const _uploadedFile: any = {
            name: file.name,
            attachmentType: "LOGO",
            size: file.size,
            type: file.type,
            data: imgData,
            entityId: 0,
            isPrimary: false,
          };

          _uploadedFile.label = file.name;

          AxiosAPI.saveBusinessAttachment(_uploadedFile)
            .then((res: any) => {
              //set_documents([...documents, _uploadedFile]);
              setLoadingLogo(false);
              message.success(
                'File "' + _uploadedFile.label + '" uploaded successfully!'
              );
            })
            .catch((error: any) => {
              message.success('Error uploading "' + _uploadedFile.label + '"');
            });
        };
      });
    },
  };

  const [messageApi, contextHolder] = message.useMessage();
  const removeFileAttachment = (fileObject: any) => {
    //console.warn("::: fileObject :::", fileObject);

    const modalConfirmAttachmentDelete: any = Modal.confirm({
      centered: true,
      title: "Remove attachment?",
      icon: <ExclamationCircleFilled />,
      content: "Are you sure you want to remove the file: " + fileObject.name,
      onOk() {
        return new Promise((resolve, reject) => {
          AxiosAPI.removeFileAttachment(fileObject.s3Key)
            .then((res: any) => {
              //console.warn("::: DELETE ATTACHMENT RESULT :::", res.data);
              modalConfirmAttachmentDelete.destroy();
              messageApi.open({
                type: "success",
                content: "Attachment removed successfully",
              });
            })
            .catch((error: any) => {
              //console.warn("::: DELETE ATTACHMENT ERROR :::", error);
            });
        }).catch(() => {
          messageApi.open({
            type: "error",
            content: "Error removing attachment",
          });
        });
      },
      onCancel() {
        //console.log("Cancel");
      },
    });
  };

  const [loadingCarousel, setLoadingCarousel] = useState(false);
  const propsCarousel: UploadProps = {
    beforeUpload(file) {
      setLoadingCarousel(true);
      return new Promise((resolve: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const imgData: string = reader.result as string;

          const image = new Image();
          image.src = imgData;
          image.onload = () => {
            const { width } = image;

            if (width < 1230) {
              messageApi.open({
                type: "error",
                content:
                  "Minimum width of uploaded banner must be is 1230 pixels",
              });
              setLoadingCarousel(false);
              return;
            }

            const _uploadedFile: any = {
              name: file.name,
              attachmentType: "MINI_SITE_BANNER",
              size: file.size,
              type: file.type,
              data: imgData,
              entityId: 0,
              isPrimary: false,
            };

            _uploadedFile.label = file.name;

            AxiosAPI.saveBusinessAttachment(_uploadedFile)
              .then((res: any) => {
                set_documents([...documents, _uploadedFile]);

                setLoadingCarousel(false);

                message.success(
                  'File "' + _uploadedFile.label + '" uploaded successfully!'
                );
              })
              .catch((error: any) => {
                message.success(
                  'Error uploading "' + _uploadedFile.label + '"'
                );
                setLoadingCarousel(false);
              });
          };
        };
      });
    },
  };

  const [loadingSliders, setLoadingSliders] = useState(false);

  const propsSliders: UploadProps = {
    beforeUpload(file) {
      setLoadingSliders(true);
      return new Promise((resolve: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const imgData: string = reader.result as string;

          const _uploadedFile: any = {
            name: file.name,
            attachmentType: "SLIDE_IMAGE",
            size: file.size,
            type: file.type,
            data: imgData,
            entityId: 0,
            isPrimary: false,
          };

          _uploadedFile.label = file.name;

          AxiosAPI.saveBusinessAttachment(_uploadedFile)
            .then((res: any) => {
              set_documents([...documents, _uploadedFile]);

              setLoadingSliders(false);

              message.success(
                'File "' + _uploadedFile.label + '" uploaded successfully!'
              );
            })
            .catch((error: any) => {
              message.success('Error uploading "' + _uploadedFile.label + '"');
              setLoadingSliders(false);
            });
        };
      });
    },
  };
  // - END ATTACHMENT -
  const [loadingBusinessDocument, setLoadingBusinessDocument] = useState(false);

  const [imageUrlBusinessDocument, setImageUrlBusinessDocument] =
    useState<string>(
      "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
    );
  const propsBusinessDocument: UploadProps = {
    beforeUpload(file) {
      setLoadingBanner(true);
      return new Promise((resolve: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const imgData: string = reader.result as string;

          setImageUrlBusinessDocument(imgData);

          //console.log("****", imgData);

          const _uploadedFile: any = {
            name: file.name,
            attachmentType: currentFileAttachmentType,
            size: file.size,
            type: file.type,
            data: imgData,
            entityId: 0,
            isPrimary: false,
          };

          _uploadedFile.label = file.name;

          AxiosAPI.saveBusinessAttachment(_uploadedFile)
            .then((res: any) => {
              set_documents([...documents, _uploadedFile]);
              setLoadingBusinessDocument(false);

              message.success(
                'File "' + _uploadedFile.label + '" uploaded successfully!'
              );
            })
            .catch((error: any) => {
              message.success('Error uploading "' + _uploadedFile.label + '"');
              setLoadingBusinessDocument(false);
            });
        };
      });
    },
  };

  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  // - BANNER -

  const [loadingBanner, setLoadingBanner] = useState(false);

  const propsBanner: UploadProps = {
    beforeUpload(file) {
      setLoadingBanner(true);
      return new Promise((resolve: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const imgData: string = reader.result as string;

          setImageUrlBanner(imgData);

          //console.log("****", imgData);

          const _uploadedFile: any = {
            name: file.name,
            attachmentType: "MINI_SITE_BANNER",
            size: file.size,
            type: file.type,
            data: imgData,
            entityId: 0,
            isPrimary: false,
          };

          _uploadedFile.label = file.name;

          AxiosAPI.saveBusinessAttachment(_uploadedFile)
            .then((res: any) => {
              set_documents([...documents, _uploadedFile]);
              setLoadingBanner(false);

              message.success(
                'File "' + _uploadedFile.label + '" uploaded successfully!'
              );
            })
            .catch((error: any) => {
              message.success('Error uploading "' + _uploadedFile.label + '"');
              setLoadingBanner(false);
            });
        };
      });
    },
  };

  // - END BANNER -
  ////////////////////////////////////////////////////////////////////////

  return (
    <>
      <div className="card mb-5">
        <div className="card-header border-0 cursor-pointer">
          <div className="card-title m-0">
            <h3 className="fw-bolder m-0">Business Documents</h3>
          </div>
        </div>
        <div className="collapse show">
          <div className="card-body border-top p-9">
            <>
              <Row>
                <Col className="" xs={24} sm={24} md={12} lg={12} xl={12}>
                  <div className="card mb-5">
                    <div className="card-header border-0 cursor-pointer">
                      <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">General Documents</h3>
                      </div>
                    </div>
                    <div className="card-body border-top ">
                      <Row className="p-2" justify="space-around" align="top">
                        <Col span={8}>
                          <>
                            <h6 className="mb-2">
                              <strong>Logo</strong>
                            </h6>
                            <div className="ant-upload-wrapper">
                              <div className="ant-upload-list-item-container">
                                <div className="upload-image-wrapper">
                                  <AntImage
                                    src={imageUrlLogo}
                                    alt={imageUrlLogo}
                                    className="ant-upload-list-item-image"
                                    fallback={fallBackImage}
                                  />
                                </div>
                              </div>
                            </div>
                            <ImgCrop rotationSlider>
                              <Upload {...propsLogo}>
                                <Button
                                  icon={
                                    loadingLogo ? (
                                      <LoadingOutlined />
                                    ) : (
                                      <UploadOutlined />
                                    )
                                  }
                                >
                                  {loadingLogo ? "Wait..." : "Upload"}
                                </Button>
                              </Upload>
                            </ImgCrop>
                          </>
                        </Col>

                        <Col span={1}></Col>

                        <Col span={15} className="wide-uploader">
                          <>
                            <h6 className="mb-2">
                              <strong>Video URL</strong>
                            </h6>
                            <Row className="p-2">
                              <Col span={24}>
                                <input
                                  type="text"
                                  title="Youtube video"
                                  name="profileVideoUrl"
                                  className="form-control form-control-lg form-control-solid w-100 is-select mb-4"
                                  placeholder="Add video url"
                                  value={profileVideoUrl}
                                  onChange={(e) => {
                                    set_profileVideoUrl(e.target.value);
                                  }}
                                />
                              </Col>
                              <Col span={24}>
                                <ul className="mt-0">
                                  <li>
                                    Go to your video page and copy the url..
                                  </li>
                                  <li>Paste the url in the field above</li>
                                </ul>
                              </Col>
                            </Row>
                          </>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <hr
                    style={{
                      borderColor: "#eff2f5",
                      backgroundColor: "#eff2f5",
                      height: "2px",
                    }}
                  />

                  <div className="card mb-5">
                    <div className="card-header border-0 cursor-pointer">
                      <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                          Banner Carousel Images
                        </h3>
                      </div>
                    </div>
                    <div className="card-body border-top ">
                      <Row className="p-2 profile-images">
                        <ImgCrop rotationSlider aspect={1230 / 340}>
                          <Upload
                            listType="picture-card"
                            fileList={bannerCarouselList}
                            onRemove={removeFileAttachment}
                            {...propsCarousel}
                          >
                            {bannerCarouselList.length < 5 &&
                              (loadingCarousel ? (
                                <LoadingOutlined />
                              ) : (
                                "+ Upload"
                              ))}
                          </Upload>
                        </ImgCrop>
                      </Row>
                    </div>
                  </div>

                  <div className="card mb-5">
                    <div className="card-header border-0 cursor-pointer">
                      <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                          Company Profile Carousel Images
                        </h3>
                      </div>
                    </div>
                    <div className="card-body border-top ">
                      <Row className="p-2 profile-images">
                        <ImgCrop rotationSlider aspect={355 / 230}>
                          <Upload
                            listType="picture-card"
                            fileList={sliderList}
                            onRemove={removeFileAttachment}
                            {...propsSliders}
                          >
                            {sliderList.length < 5 &&
                              (loadingSliders ? (
                                <LoadingOutlined />
                              ) : (
                                "+ Upload"
                              ))}
                          </Upload>
                        </ImgCrop>
                      </Row>
                    </div>
                  </div>
                </Col>

                <Col className="" xs={24} sm={24} md={12} lg={12} xl={8}>
                  <div className="card mb-5 m-ml-5">
                    <div className="card-header border-0 cursor-pointer">
                      <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">Other Documents</h3>
                      </div>
                    </div>
                    <div className="card-body border-top ">
                      <Row className="p-2">
                        <Col span={24} className="mb-6">
                          <select
                            className="form-control form-control-lg form-control-solid w-100 is-select"
                            value={currentFileAttachmentType}
                            onChange={(e: any) => {
                              setcurrentFileAttachmentType(e.target.value);
                            }}
                          >
                            <option value="" selected>
                              Select attachment type...
                            </option>
                            <option value="PRODUCT_CERTIFICATE">
                              Product Certificate
                            </option>
                            <option value="TECHNICAL_SPECIFICATION_SHEET">
                              Technical Data Sheet
                            </option>
                            <option value="OTHER">Other Document</option>
                          </select>
                        </Col>
                        <Col span={24} style={{ height: "fit-content" }}>
                          <Dragger {...propsBusinessDocument}>
                            <p className="ant-upload-drag-icon">
                              <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                              Click or drag file to this area to upload
                            </p>
                            <p className="ant-upload-hint">
                              <br />
                              <ul className="download-specs">
                                {[
                                  "PRODUCT_CERTIFICATE",
                                  "TECHNICAL_SPECIFICATION_SHEET",
                                  "DOCUMENT",
                                ].includes(currentFileAttachmentType) && (
                                  <li>
                                    Permitted file formats include DOCX (.docx),
                                    DOC (.doc) and PDF (.pdf).
                                  </li>
                                )}
                                <li>Image size must not be more than 5MB.</li>
                                <li>
                                  Do not use unauthorized third-party brand
                                  logos and product images.
                                </li>
                              </ul>
                            </p>
                          </Dragger>
                          <br />
                          <br />
                          <span className="ant-upload-wrapper">
                            <div className="ant-upload-list ant-upload-list-picture">
                              {documents.map(
                                (document: any, documentIndex: number) => (
                                  <>
                                    {![
                                      "MINI_SITE_BANNER",
                                      "LOGO",
                                      "SLIDE_IMAGE",
                                    ].includes(document.type) && (
                                      <div
                                        key={documentIndex}
                                        className="ant-upload-list-item-container file-attachment-item"
                                      >
                                        <FileAttachmentNoActionButton
                                          cb={null}
                                          s3Key={document.s3Key}
                                          label={document.label}
                                          type={document.type}
                                          isImage={[
                                            "jpg",
                                            "jpeg",
                                            "gif",
                                            "png",
                                            "webp",
                                          ].includes(
                                            document.label.split(".")[1]
                                          )}
                                        />
                                      </div>
                                    )}
                                  </>
                                )
                              )}
                            </div>
                          </span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export { BusinessDocuments };
